module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news-card"
  }, [_c('div', {
    staticClass: "news-card__content"
  }, [_c('h2', {
    staticClass: "news-card__header"
  }, [_vm._v("Доступны новые сервисы!")]), _c('p', {
    staticClass: "news-card__text"
  }, [_vm._v("В верхнем меню доступен новый раздел \"расширения\".")]), _c('p', {
    staticClass: "news-card__text"
  }, [_vm._v("В этом разделе собраны все доступные расширения личного кабинета. Эти сервисы помогают упростить организацию процесса обучения и сделать его удобным и эффективным.")])]), _c('div', {
    staticClass: "news-card__image"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36d10bfe","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/news/NewsCard.vue
// module id = f235d812ddb5e1468816
// module chunks = 89